import type {ConnectElementConfig} from '../ConnectElementList';
import {ComponentOverrideFlag} from '../../../utils/flags/flags';

const INSTANT_PAYOUTS_HTML_ATTRIBUTE = 'instant-payouts' as const;
const SHOW_MANUAL_PAYOUT_SCHEDULE_CONTACT_PLATFORM_MESSAGE_ATTRIBUTE =
  'show-manual-payout-schedule-contact-platform-message' as const;
const HIDE_MANUAL_PAYOUT_SCHEDULE_STATUS_ATTRIBUTE =
  'hide-manual-payout-schedule-status' as const;

const balancesComponentParams = [INSTANT_PAYOUTS_HTML_ATTRIBUTE] as const;
type PayoutsBalanceComponentParams = (typeof balancesComponentParams)[number];
export type PayoutsBalanceComponentHtmlParams = Partial<
  Record<PayoutsBalanceComponentParams, string>
>;

export const BalancesConfig: ConnectElementConfig = {
  Component: () =>
    import(
      /* webpackChunkName: "balances" */ '../../../components/Payouts/Balance/Balance'
    ),
  enabledKey: 'balances',
  enabledOverrideFlag: ComponentOverrideFlag.balances,
  htmlAttributes: {
    [INSTANT_PAYOUTS_HTML_ATTRIBUTE]: {
      isInternal: true,
    },
    [SHOW_MANUAL_PAYOUT_SCHEDULE_CONTACT_PLATFORM_MESSAGE_ATTRIBUTE]: {
      isInternal: true,
    },
    [HIDE_MANUAL_PAYOUT_SCHEDULE_STATUS_ATTRIBUTE]: {
      isInternal: true,
    },
  },
  customHtmlElementMethods: {
    setShowManualPayoutScheduleContactPlatformMessage: {
      type: 'AttributeSettingMethod',
      attribute: SHOW_MANUAL_PAYOUT_SCHEDULE_CONTACT_PLATFORM_MESSAGE_ATTRIBUTE,
      isInternal: true,
      description:
        'Sets the show-manual-payout-schedule-contact-platform-message attribute to control whether the balances component renders a message about contacting the platform for manual payout schedule.',
    },
    setHideManualPayoutScheduleStatus: {
      type: 'AttributeSettingMethod',
      attribute: HIDE_MANUAL_PAYOUT_SCHEDULE_STATUS_ATTRIBUTE,
      isInternal: true,
      description:
        'Sets the hide-manual-payout-schedule-status attribute to control whether the "Next payout Manual" status is hidden in the balances component.',
    },
  },
  releaseState: 'ga',
  sentryTeam: 'accounts_ui',
  teamOwner: 'connected-account-experiences-eng',
  description:
    'Renders the balance for the account. Allows for manual payouts, instant payouts, and management of payout schedule.',
  friendlyName: 'Balances',
  docSitePath: '/connect/supported-embedded-components/balances',
};
